namespace TabAurous.Inventory {
    export interface SKURepricingLaborRow {
        TransLbrId?: number;
        TransactionId?: number;
        ItemTypeId?: number;
        AttributeId?: number;
        ProcessId?: number;
        Pieces?: number;
        Weight?: number;
        Parts?: number;
        CalcOnId?: number;
        CalcOn?: string;
        LabourRate?: number;
        MarkUp?: number;
        LabourAmount?: number;
        DiscountPercent?: number;
        Discount?: number;
        ProductTypeId?: number;
        ProductTypeName?: string;
        CategoryId?: number;
        CategoryName?: string;
        SubCategoryId?: number;
        SubCategoryName?: string;
        BrandId?: number;
        CollectionId?: number;
        SuperTypeId?: number;
        StoneColorId?: number;
        ShapeId?: number;
        SieveId?: number;
        QualityId?: number;
        StoneSizeId?: number;
        ProcessName?: string;
        Attribute?: string;
        WstPer?: number;
        WstWt?: number;
        IsCustomerItem?: boolean;
        CCLabourAmount?: number;
        CalculateTo?: number;
    }

    export namespace SKURepricingLaborRow {
        export const idProperty = 'TransLbrId';
        export const nameProperty = 'ProcessName';
        export const localTextPrefix = 'Inventory.SKURepricingLabor';
        export const deletePermission = 'Inventory:SKURepricing:Delete';
        export const insertPermission = 'Inventory:SKURepricing:Add';
        export const readPermission = '*';
        export const updatePermission = 'Inventory:SKURepricing:Edit';

        export declare const enum Fields {
            TransLbrId = "TransLbrId",
            TransactionId = "TransactionId",
            ItemTypeId = "ItemTypeId",
            AttributeId = "AttributeId",
            ProcessId = "ProcessId",
            Pieces = "Pieces",
            Weight = "Weight",
            Parts = "Parts",
            CalcOnId = "CalcOnId",
            CalcOn = "CalcOn",
            LabourRate = "LabourRate",
            MarkUp = "MarkUp",
            LabourAmount = "LabourAmount",
            DiscountPercent = "DiscountPercent",
            Discount = "Discount",
            ProductTypeId = "ProductTypeId",
            ProductTypeName = "ProductTypeName",
            CategoryId = "CategoryId",
            CategoryName = "CategoryName",
            SubCategoryId = "SubCategoryId",
            SubCategoryName = "SubCategoryName",
            BrandId = "BrandId",
            CollectionId = "CollectionId",
            SuperTypeId = "SuperTypeId",
            StoneColorId = "StoneColorId",
            ShapeId = "ShapeId",
            SieveId = "SieveId",
            QualityId = "QualityId",
            StoneSizeId = "StoneSizeId",
            ProcessName = "ProcessName",
            Attribute = "Attribute",
            WstPer = "WstPer",
            WstWt = "WstWt",
            IsCustomerItem = "IsCustomerItem",
            CCLabourAmount = "CCLabourAmount",
            CalculateTo = "CalculateTo"
        }
    }
}
